import { Button, MenuItem, Position, Tooltip } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  padding-left: 5px;
  padding-right: 5px;
`;

const ButtonText = styled.span`
  display: block;
  overflow: hidden;
  width: 100px;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const itemRenderer = (fontFamily, { handleClick, modifiers }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      disabled={modifiers.disabled}
      key={fontFamily}
      onClick={handleClick}
      style={{ fontFamily }}
      text={fontFamily}
    />
  );
};

// TODO Add different font faces to sub-menu (like docs.google.com)?
// TODO Add recent (or in selected template style) font families (like docs.google.com).
const FontFamilySelect = ({ onChange, options, value }) => {
  return (
    <Select
      activeItem={value}
      filterable={false}
      itemRenderer={itemRenderer}
      items={options}
      noResults={<MenuItem disabled text="No results." />}
      onItemSelect={onChange}
      popoverProps={{ position: Position.BOTTOM_LEFT }}
    >
      <Tooltip content="Font" placement="bottom">
        <StyledButton
          minimal
          rightIcon="caret-down"
          style={{ fontFamily: value }}
          text={<ButtonText>{value}</ButtonText>}
        />
      </Tooltip>
    </Select>
  );
};

FontFamilySelect.defaultProps = {
  onChange: () => {},
  options: undefined,
  value: undefined,
};

FontFamilySelect.propTypes = {
  onChange: PropTypes.func,
  options: PropTypes.array,
  value: PropTypes.string,
};

export default FontFamilySelect;
